import { secureFetch } from './authService';
import {API_BASE_URL, PAGINATION_DEFAULT_LIMIT} from './constants';

export function getAlertMessages(query) {
	let url = API_BASE_URL + `/update/messages/?`;
	if (query) {
		const {
			companyId,
			limit = PAGINATION_DEFAULT_LIMIT,
			mobileAppSetId,
			page = 0,
			sorting,
			userId
		} = query;

		if (companyId) {
			url = url + `&companyId=${companyId}`
		}
		if (limit) {
			url = url + `&limit=${limit}`;
		}
		if (mobileAppSetId) {
			url = url + `&mobileAppSetId=${mobileAppSetId}`
		}
		if (page || page === 0) {
			url = url + `&page=${page}`;
		}
		if (sorting) {
			url = url + `&sortParam=${sorting.name}&sort=${sorting.desc ? 'ASC' : 'DESC'}`;
		}
		if (userId) {
			url = url + `&userId=${userId}`
		}
	}

	return secureFetch(url, {
		method: 'GET',
	});
}

export function getAlertNotifications(query) {
	let url = API_BASE_URL + `/update/notifications/?`;

	if (query) {
		const {
			companyId,
			limit = PAGINATION_DEFAULT_LIMIT,
			mobileAppSetId,
			page = 0,
			sorting,
			type,
			localizationCode
		} = query;

		if (companyId) {
			url = url + `&companyId=${companyId}`
		}
		if (limit) {
			url = url + `&limit=${limit}`;
		}
		if (mobileAppSetId) {
			url = url + `&mobileAppSetId=${mobileAppSetId}`
		}
		if (page || page === 0) {
			url = url + `&page=${page}`;
		}
		if (sorting) {
			url = url + `&sortParam=${sorting.name}&sort=${sorting.desc ? 'ASC' : 'DESC'}`;
		}
		if (type) {
			url = url + `&type=${type}`
		}
		if (localizationCode) {
			url = url + `&localizationCode=${localizationCode}`
		}
	}

	return secureFetch(url, {
		method: 'GET',
	});
}

export function changeAlertNotificationsType(newType) {
	return secureFetch(API_BASE_URL + '/update/notifications/save/batch', {
		method: 'POST',
		body: JSON.stringify(newType)
	});
}

export function changeAlertMessagesType(newType) {
	return secureFetch(API_BASE_URL + '/update/notifications/save/batch', {
		method: 'POST',
		body: JSON.stringify(newType)
	});
}

export function confirmUpdates(data) {
	return secureFetch(API_BASE_URL + '/update/notifications/new/batch', {
		method: 'POST',
		body: JSON.stringify(data)
	});
}



// WEBPACK FOOTER //
// ./src/helpers/alertService.js